<div class="card border-0 shadow-sm">
    <div class="card-header text-light border-0 bg-secondary">
        Download App
    </div>
    <div class="card-body" style="min-height: 30vh;">
        <div class="card shadow p-1 border-warning">
            <ul class="list-group">
                <li class="list-group-item justify-content-between align-items-end">
                    <span>
                        <i class="fa-brands fa-apple me-2"></i>
                         Mac - Apple Silicon
                    </span>
                    <button type="button" class="btn btn-sm float-end" [ngClass]="{'btn-warning':isMac(), 'btn-light':!isMac()}" (click)="download('armdmg')"><i class="fas fa-download"></i></button>
                </li>
                <li class="list-group-item justify-content-between align-items-end">
                    <span>
                        <i class="fa-brands fa-apple me-2"></i>
                         Mac - Apple Intel
                    </span>
                    <button type="button" class="btn btn-sm float-end" [ngClass]="{'btn-warning':isMac(), 'btn-light':!isMac()}"  (click)="download('dmg')"><i class="fas fa-download"></i></button>
                </li>
                <li class="list-group-item justify-content-between align-items-end">
                    <span>
                        <i class="fa-brands fa-windows me-2"></i>
                        Windows
                    </span>
                    <button type="button" class="btn btn-sm float-end" [ngClass]="{'btn-warning':isWindows(), 'btn-light':!isWindows()}" (click)="download('exe')"><i class="fas fa-download"></i></button>
                </li>
              </ul>
        </div>
    </div>


    <div class="card-footer border-0">
       <span class="float-end">
        <button class="btn btn-secondary btn-sm text-light" (click)="dialogRef.close()">
            Close
        </button>
       </span>
    </div>  
</div>